import CommonAudio from '../commons/Audio'

export default class DocumentAudio extends CommonAudio {}
